import isTeaserBiData from './isTeaserBiData';

export default isTeaserBiData;
